/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Navbar , Form , Button , Card , Row , Col , Nav , NavDropdown} from 'react-bootstrap'
import {BackButton} from '../components';
import {GradeBook , Exam} from '../components/reports'

export default class ReportsScreen extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            "tab":this.props.match.params.tab,
            "classUID":this.props.match.params.id,
            "name":"White Class",
            "summary":"Grade Book - 3rd Period English"
        };
    }

    hasSelectedClassChanged(newClassUID){
        return this.state.classUID != newClassUID;
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){
        this.props = props;

        if(this.hasSelectedClassChanged(this.props.match.params.id))
        {
            console.log("class-swap");
        }

        this.props = props;

        this.setState({
            "tab":this.props.match.params.tab,
            "classUID":this.props.match.params.id
        });

    }

    handleSelect(eventKey) {
        window.location.hash = "classes/"+eventKey+'/'+this.state.classUID
    }

    getBody(){

        switch(this.props.match.params.reportID)
        {
            case 'exam' : return <Exam/>
            case 'grade' :return <GradeBook/>
            default : return <h1>No tab selected</h1>
        }

    }

    render(){




        return <div >
                <Row>
                    <Col sm={12} md={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col md={12}>
                                        <table>
                                            <tr>
                                                <td valign="top"><BackButton/></td>
                                                <td><Card.Title>{this.state.name}</Card.Title></td>
                                            </tr>
                                            <tr> <td colspan={2}><Card.Title className="mb-2 text-muted">{this.state.summary}</Card.Title></td></tr>
                                        </table>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <br/>

                                {this.getBody()}

                    </Col>
                </Row>
        </div>
    }


}